import { useMutation } from 'react-query';
import { httpService } from '../../../services/http.service';
import { BASE_URL } from '../../../constants/endpoints';
import { IServerErrorResponse } from '../../../types';
import { flattenServerErrorResponse } from '../../../helpers/errors.helper';
import { trackMixPanel } from '../../../services/mixpanel.service';
import { useStore } from '../../../store';

interface IProps {
  supplierExternalId: string
}

export const useDeleteSupplier = (handleError: (errMsg: string) => void) => {
  const { customerId } = useStore(state => state.user);
  const { accountExternalId } = useStore(state => state.getPersonalAccount());
  return useMutation('DeleteSupplier', async ({ supplierExternalId }:IProps) => {
    const res = await httpService.delete(`${BASE_URL}/api/v1/user/${customerId}/${accountExternalId}/supplier/${supplierExternalId}/delete`);
    return res.data;
  }, {
    retry: 0,
    onError: (e:IServerErrorResponse) => {
      const { localizedMessage, code } = flattenServerErrorResponse(e);
      handleError(localizedMessage);
      trackMixPanel('Error Occurred During Move Money Flow', {
        'Error Code': code, 'Error Message': localizedMessage, 'Screen Name': 'Supplier Form', Flow: 'Mail a Check',
      });
    },
  });
};
